import { useQuery } from "@tanstack/react-query";
import contactsService from "services/admin/contactsService";

export const useGetContacts = (queryParams = {}) => {
    return useQuery({
        queryKey: ['contacts', queryParams],
        queryFn: async () => {
            const response = await contactsService.getAll(queryParams);
            return response.data;
        },        
        refetchOnWindowFocus: false,
    });
};